<template>
  <div>
    <div class="card" v-if="dataReady == true">
      <div class="card-header">
        Loans - You have used {{this.$store.state.loansList.clubCount}} of 4 loans
      </div>
      <div class="card-body">
        <CDataTable
        :items="this.teamPlayers"
        :fields="[{key:'team_name', label:'', filter:false, sorter:false}, {key:'last_name', label:'Player'}, {key:'original_cost', label:'Cost'}, {key:'total_points', label:'Total'}, {key:'player_id', label:'', filter:false, sorter:false}]"
        hover
        striped
        bordered
        small
        fixed
    >
        <template #team_name="{item}">
        <td>
            <img width="24px" height="32px" :src="'img/team-kits/shirt_' + item.team_name_short + '-66.webp'" :alt="item.team_name" />
        </td>
        </template>
        <template #last_name="{item}">
          <TablePlayerItem :item="item" />
        </template>
        <template #player_id="{item}">
        <td>
            <CButton block variant="outline" :disabled="!dropEnabled(item)" :color="dropEnabled(item) ? 'primary' : 'secondary'" size="sm" :id="item.player_id" @click="showDropModal(item)">Bench</CButton>
        </td>
        </template>
        </CDataTable>
        <CModal
        title="Select loan player"
        :show.sync="loanModal"
        color="primary"
        >
          <CDataTable
        :items="this.loanPlayers"
        :fields="[{key:'team_name', label:'', filter:false, sorter:false}, {key:'last_name', label:'Player'}, {key:'original_cost', label:'Cost'}, {key:'total_points', label:'Total'}, {key:'player_id', label:'', filter:false, sorter:false}]"
        sorter
        hover
        striped
        bordered
        small
        fixed
    >
        <template #team_name="{item}">
        <td>
            <img width="24px" height="32px" :src="'img/team-kits/shirt_' + item.team_name_short + '-66.webp'" :alt="item.team_name" />
        </td>
        </template>
        <template #last_name="{item}">
          <TablePlayerItem :item="item" />
        </template>
        <template #player_id="{item}">
        <td>
            <CButton block variant="outline" color="primary" size="sm" :id="item.player_id" @click="applyPlayerLoan(item)">Loan</CButton>
        </td>
        </template>
        </CDataTable>

            <template v-slot:footer>
                <CButton color="secondary" @click="bidModal = false">Cancel</CButton>
            </template>
        </CModal>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Data needed
 * * get auction list - already have an API
 * * get all loan in transactions for window & total transactions for club
 * * get current team - already have an API
 * 
 * UI
 * * list out players in team with "out" button
 * * on click open popup with list of available players and "in" button
 * * clicking in will send loan to system and update team display
 * 
 * 
 */
import TablePlayerItem from '../base/TablePlayerItem.vue'

export default {
  name: 'Loans',
  data () {
    return {
      loanModal: false,
      dropPlayer: {},
      currentWindow: 0
    }
  },
  components: { TablePlayerItem },
  created() {
    this.$store.dispatch("loadSiteVarsList");

    if(this.isAuthenticated) {
      this.requestData();
    }
  },
  methods: {
    requestData: function() {
      if(this.$store.state.auctionList.length == 0) {
        this.$store.dispatch("loadAuctionList");
      }
  
      if(this.$store.state.leaderboard.length == 0) {
        this.$store.dispatch("loadLeaderboard");
      }
      
      this.$store.dispatch("loadLoanList", {clubId:this.$auth.user['https://tlog-online.co.uk/club_id'],
                                            windowId: this.$helpers.getSiteVar("current_window", this)});

      this.currentWindow = this.$helpers.getSiteVar("current_window", this);
    },
    showDropModal: function(player) {
      this.dropPlayer = player;
      this.loanModal = true;
    },
    dropEnabled: function(player) {
      var loansList = this.$store.state.loansList.loans;
      return player.transfer.length == 0 && 
              loansList.filter(el => el.playerout == player.player_id && el.windowid == this.currentWindow).length == 0 &&
              Number(this.$store.state.loansList.clubCount) < 4;
    },
    applyPlayerLoan(player) {
      this.$store.dispatch("savePlayerLoan", {clubId: Number(this.$auth.user['https://tlog-online.co.uk/club_id']),
                                            windowId: Number(this.currentWindow),
                                            startWeek: Number(this.$helpers.getSiteVar("current_week", this))+1,
                                            playerOut: Number(this.dropPlayer.player_id),
                                            playerIn: Number(player.player_id)});
      this.loanModal = false;
    }
  },
  watch: {
    isAuthenticated(newValue, oldValue) {
      if(newValue == true) {
        this.requestData();
      }
    }
  },
  computed: {
    isAuthenticated() {
      return this.$auth.isAuthenticated && this.$auth.user['https://tlog-online.co.uk/club_id'] && this.$store.state.siteVarsList.list.length > 0;
    },
    clubId() {
      return this.$auth.user['https://tlog-online.co.uk/club_id'];
    },
    dataReady: function() {
      return this.$store.state.auctionList.length > 0 &&
              this.$store.state.leaderboard.length > 0 &&
                this.$store.state.loansList.success == true;
    },
    teamPlayers: function() {
      if(this.$store.state.leaderboard.length > 0) {
        var clubId = this.clubId;
        return this.$store.state.leaderboard.filter(el => el.club_id == clubId)[0].players;
      }
      return [];
    },
    loanPlayers: function() {
      if(this.dataReady) {
        var list = [];
        var auctionList = this.$store.state.auctionList;
        var loansList = this.$store.state.loansList.loans;
        var position = this.dropPlayer.position_short;
        var dropPlayerCost = Number(this.dropPlayer.original_cost);

        auctionList.forEach(element => {
          if(element.position_short == position && Number(element.original_cost) <= dropPlayerCost && loansList.filter(el => el.playerin == element.player_id || el.windowid != this.currentWindow).length == 0) {
            list.push(element);
          }
        });
        return list;
      }
      return [];
    }
  }
}
</script>
